import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DredgingService } from 'src/app/core/_services/dredging.service';
import { Combustible } from 'src/app/core/_models/combustible';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';

export interface DialogCreateDredgingFuelData {
  perimeterId?: string;
}

@Component({
  selector: 'app-dialog-create-dredging-fuel',
  templateUrl: './dialog-create-dredging-fuel.component.html',
  styleUrls: ['./dialog-create-dredging-fuel.component.scss']
})
export class DialogCreateDredgingFuelComponent {
  displayName = '';
  code = '';
  isSubmitting = false;

  constructor(
    public dialogRef: MatDialogRef<DialogCreateDredgingFuelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogCreateDredgingFuelData,
    private dredgingService: DredgingService,
    private snackbarService: SnackbarService
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onSubmit(): void {
    if (!this.displayName || !this.code) return;

    this.isSubmitting = true;

    const combustible: Combustible = {
      displayName: this.displayName,
      code: this.code
    };

    this.dredgingService.add(combustible).subscribe({
      next: (result) => {
        this.isSubmitting = false;
        this.dialogRef.close(result);
      },
      error: () => {
        this.snackbarService.open(SnackbarTypes.error);
        this.isSubmitting = false;
      }
    });
  }

  isFormValid(): boolean {
    return !!this.displayName && !!this.code;
  }
}
